export enum PaymentType {
  Invoice = 'Invoice',
  Windcave = 'Windcave',
  FinancialSynergy = 'FinancialSynergy',
}
